import { makeDashboardDetailsActionMenuStyles } from '../DashboardDetailsActionMenu.styles';

export const makeTaskDetailsActionMenuStyles = makeDashboardDetailsActionMenuStyles;
